export default "__VITE_ASSET__CxDmOnWp__"